import { render } from "./DocLogout.vue?vue&type=template&id=4d984dd6&ts=true"
import script from "./DocLogout.vue?vue&type=script&lang=ts"
export * from "./DocLogout.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__